// Device type maps
export const dockTypes = ['DJI_DOCK_3', 'IDI_DOCK_S', 'ADS600', 'PDS', 'ADS1000']
export const rcTypes = [
  'DJI_RC_Pro',
  'DJI_RC_Plus',
  'DJI_DOCK_3_INTERNAL_RC',
  'IDI_AQUILA_RC',
  'IDI_QUADPLANE_RC',
]
export const slinkTechTypes = ['SLINK_TECH_PORTAL']
export const deviceTypes = [...dockTypes, ...rcTypes]

export const getDeviceImage = (deviceType: string) => {
  switch (deviceType) {
    case 'DJI_RC_Pro':
      return '/images/RcPro.png'
    case 'IDI_DOCK_S':
      return '/images/device.png'
    case 'DJI_RC_Plus':
      return '/images/RcPlus.png'
    case 'DJI_DOCK_3':
      return '/images/dji_dock_3.png'
    case 'ADS600':
      return '/images/ADS600.png'
    case 'PDS':
      return '/images/PDS.png'
    case 'ADS1000':
      return '/images/ADS1000.png'
    case 'SLINK_TECH_PORTAL':
      return '/images/slink_tech.jpg'
    case 'IDI_AQUILA_RC':
      return '/images/aquilla.png'
    case 'IDI_QUADPLANE_RC':
      return '/images/quadplane.svg'
    default:
      return '/images/device.png'
  }
}

export const devices = [
  {
    name: 'DJI_RC_Plus',
    img: '/images/RcPlus.png',
    type: 'DJI_RC_Plus',
  },
  {
    name: 'DJI_RC_Pro',
    img: '/images/RcPro.png',
    type: 'DJI_RC_Pro',
  },
  {
    name: 'IDI_DOCK_S',
    img: '/images/device.png',
    type: 'IDI_DOCK_S',
  },
  {
    name: 'DJI_DOCK_3',
    img: '/images/dji_dock_3.png',
    type: 'DJI_DOCK_3',
  },
  {
    name: 'SLINK_TECH_PORTAL',
    img: '/images/slink_tech.jpg',
    type: 'SLINK_TECH_PORTAL',
  },
  {
    name: 'ADS600',
    img: '/images/ADS600.png',
    type: 'ADS600',
  },
  {
    name: 'PDS',
    img: '/images/PDS.png',
    type: 'PDS',
  },
  {
    name: 'ADS1000',
    img: '/images/ADS1000.png',
    type: 'ADS1000',
  },
  {
    name: 'IDI_AQUILA_RC',
    img: '/images/aquilla.png',
    type: 'IDI_AQUILA_RC',
    allowedOrganizations: ['52afdbe6-daf5-40e2-b1b0-8923c1cacabc'],
  },
  {
    name: 'IDI_QUADPLANE_RC',
    img: '/images/quadplane.svg',
    type: 'IDI_QUADPLANE_RC',
    allowedOrganizations: ['52afdbe6-daf5-40e2-b1b0-8923c1cacabc'],
  },
]
